import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Tab, Tabs } from "@mui/material";

import General from "Components/Client/Tabs/General";
import Communication from "Components/Client/Tabs/Communication";
import Payment from "Components/Client/Tabs/Payment";
import AgreementLevel from "Components/Client/Tabs/AgreementLevel";
import StandardTerms from "Components/Client/Tabs/StandardTerms";
import System from "Components/Client/Tabs/System";
import Uc from "Components/Client/Tabs/Uc";
import { BOOLVALUE } from "utils/options/BOOLVALUE";
import Texts from "./Tabs/Texts";
import EmailSubscription from "./Tabs/EmailSubscription";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "255px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export function ClientForm({
  formData,
  FORM_MODE,
  handleInputChange,
  countryCodes,
  languageCodes,
  services,
  agreementOptions,
  handleReplaceFormData,
  loading,
}) {
  const [tabIndex, setTabindex] = useState(0);
  const boolOptions = BOOLVALUE;

  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      {formData.Id ? (
        <Tabs
          value={tabIndex}
          onChange={handleTabSwitch}
          sx={{ marginBottom: "2rem" }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Allmänt" />
          <Tab label="Kommunikation" />
          <Tab label="Betalning" />
          <Tab label="Avtal" />
          <Tab label="Villkor" />
          <Tab label="System" />
          <Tab label="Texter" />
          <Tab label="UC" />
          <Tab label="Epostutskick" />
        </Tabs>
      ) : (
        <Tabs
          value={tabIndex}
          onChange={handleTabSwitch}
          sx={{ marginBottom: "2rem" }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Allmänt" />
          <Tab label="Kommunikation" />
          <Tab label="Betalning" />
          <Tab label="Avtal" />
          <Tab label="Villkor" />
          <Tab label="System" />
          <Tab label="Texter" />
        </Tabs>
      )}

      <TabPanel value={tabIndex} index={0}>
        <General
          client={formData}
          FORM_MODE={FORM_MODE}
          countryCodes={countryCodes}
          handleInputChange={handleInputChange}
          loading={loading}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <Communication
          client={formData}
          FORM_MODE={FORM_MODE}
          languageCodes={languageCodes}
          handleInputChange={handleInputChange}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <Payment
          client={formData}
          FORM_MODE={FORM_MODE}
          handleReplaceFormData={handleReplaceFormData}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={3}>
        <AgreementLevel
          client={formData}
          FORM_MODE={FORM_MODE}
          services={services}
          handleInputChange={handleInputChange}
          boolOptions={boolOptions}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={4}>
        <StandardTerms
          client={formData}
          FORM_MODE={FORM_MODE}
          handleInputChange={handleInputChange}
          agreementOptions={agreementOptions}
          boolOptions={boolOptions}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={5}>
        <System
          client={formData}
          FORM_MODE={FORM_MODE}
          handleInputChange={handleInputChange}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={6}>
        <Texts
          client={formData}
          handleReplaceFormData={handleReplaceFormData}
          FORM_MODE={FORM_MODE}
        />
      </TabPanel>
      {formData.Id ? (
        <>
          <TabPanel value={tabIndex} index={7}>
            <Uc
              UC={formData}
              handleInputChange={handleInputChange}
              FORM_MODE={FORM_MODE}
            />
          </TabPanel>
          <TabPanel value={tabIndex} index={8}>
            <EmailSubscription
              client={formData}
              FORM_MODE={FORM_MODE}
              handleInputChange={handleInputChange}
              loading={loading}
            />
          </TabPanel>
        </>
      ) : null}
    </>
  );
}
